<template>
  <BoxCard>
    <template #header>About the clinician</template>
    <template #content>
      <div class="mb-5 text-center flex justify-center flex-col items-center">
        <ViceAvatar
          :image="this.$page.props.session.details?.clinician?.profile_photo_url"
          :name="this.$page.props.session.details?.clinician?.name"
          class="w-12 h-12"
        />
        <p class="text-lg font-semibold text-gray-900 mt-3">
          {{ this.$page.props.session.details.clinician?.name }}
        </p>
        <p
          class="text-xs font-medium text-gray-900"
          v-if="this.$page.props.session.details.clinician?.details"
        >
          {{ this.$page.props.session.details.clinician?.details?.title }}
        </p>
        <p
          class="text-xs font-medium text-gray-900"
          v-if="this.$page.props.session.details.clinician?.details"
        >
          {{ this.$page.props.session.details.clinician?.details.position }}
        </p>
        <button
          type="button"
          class="
            flex
            m-auto
            mt-3.5
            px-4
            py-1.5
            border border-gray-300
            rounded-md
            text-xs
            font-medium
            text-gray-700
            bg-white
            hover:bg-gray-50
            focus:outline-none
            hidden
          "
        >
          Follow clinician
        </button>
      </div>
      <div
        class="relative w-96 mb-5"
        v-if="this.$page.props.session.details.clinician?.details?.intro_about"
      >
        <hr class="absolute right-6 w-full text-gray-200" />
      </div>
      <div class="mt-12" v-if="this.$page.props.session.details.clinician?.details?.intro_about">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Areas of expertise</h3>
        <div class="my-3 text-xs text-gray-800">
          {{ this.$page.props.session.details.clinician?.details?.intro_about }}
        </div>
        <div class="my-3 text-xs text-gray-800" :class="readMore ? 'block' : 'hidden'">
          {{ this.$page.props.session.details?.clinician?.details?.read_more_about }}
        </div>
        <span
          v-if="this.$page.props.session.details?.clinician?.details?.read_more_about"
          @click="toggleReadMore"
          class="text-vice-teal-500 text-xs"
        >
          {{ readMore ? 'Less' : 'Read more' }}
        </span>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import { ref } from 'vue';
import BoxCard from '@/Components/Cards/BoxCard.vue';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';

export default {
  name: 'AboutClinician',
  setup() {
    const readMore = ref(false);
    return {
      readMore,
    };
  },
  components: {
    BoxCard,
    ViceAvatar,
  },
  methods: {
    toggleReadMore() {
      this.readMore = !this.readMore;
    },
  },
};
</script>

<style scoped></style>
